<template>
  <div id="container">
    <div class="title">人车订单运单统计</div>
    <div id="gauge-content">
      <div id="y_gauge1" ref="gauge1_ref"></div>
      <div id="y_gauge2" ref="gauge2_ref"></div>
      <div id="y_gauge3" ref="gauge3_ref"></div>
      <div id="y_gauge4" ref="gauge4_ref"></div>
    </div>
  </div>
</template>

<script>

  import { mapState} from 'vuex'

  export default {
    name: 'ScwlCycleLine',
    components: {},
    computed: {
      ...mapState('bigScreenData', ['driverInfoCount','vehicleCount','waybillCount','orderCount','clientContractCount'])
    },
    watch:{
      driverInfoCount(val,old){
        if(val!=old){
          this.option_Progress1.title.text = '现在司机'
          this.option_Progress1.title.subtext = this.driverInfoCount + '人'
          this.y_gauge1.setOption(this.option_Progress1)
        }
      },
      vehicleCount(val,old){
        if(val!=old){
          this.option_Progress2.title.subtext = this.vehicleCount + '辆'
          this.y_gauge2.setOption(this.option_Progress2)
        }
      },
      waybillCount(val,old){
        if(val!=old){
          this.option_Progress3.title.subtext = this.waybillCount + '单'
          this.y_gauge3.setOption(this.option_Progress3)
        }
      },
      orderCount(val,old){
        if(val!=old){
          // this.option_Progress4.title.subtext = this.orderCount + '单'
          this.option_Progress4.title.subtext = this.clientContractCount + '个'
          this.y_gauge4.setOption(this.option_Progress4)
        }
      }
    },
    data () {
      return {
        y_gauge1: null,
        y_gauge2: null,
        y_gauge3: null,
        y_gauge4: null,
        //环形进度条设置对象
        option_Progress1: {
          title: {
            text: '',
            subtext: '100%',
            x: 'center',
            y: 50,
            itemGap: 10,
            textStyle: {
              color: '#B7E1FF',
              fontWeight: 'normal',
              fontFamily: '微软雅黑',
              fontSize: 10
            },
            subtextStyle: {
              color: '#B7E1FF',
              fontWeight: 'bolder',
              fontSize: 10,
              fontFamily: '微软雅黑'
            }
          },
          series: [{
            type: 'pie',
            center: ['50%', '50%'],
            radius: [41, 45],
            x: '0%',
            tooltip: { show: false },
            data: [{
              name: '数量',
              value: 100,
              itemStyle: { color: 'rgba(0,153,255,0.8)' },
              hoverAnimation: false,
              label: {
                show: false,
                position: 'center',
                textStyle: {
                  fontFamily: '微软雅黑',
                  fontWeight: 'bolder',
                  color: '#B7E1FF',
                  fontSize: 10
                }
              },
              labelLine: {
                show: false
              }
            },
              {
                name: '79%',
                value: 0,
                itemStyle: { color: 'rgba(0,153,255,0.1)' },
                hoverAnimation: false,
                label: {
                  show: false,
                  position: 'center',
                  padding: 20,
                  textStyle: {
                    fontFamily: '微软雅黑',
                    fontSize: 10,
                    color: '#B7E1FF'
                  }
                },
                labelLine: {
                  show: false
                }
              }]
          },
            {
              type: 'pie',
              center: ['50%', '50%'],
              radius: [47, 50],
              x: '0%',
              hoverAnimation: false,
              data: [{
                value: 100,
                itemStyle: { color: 'rgba(0,153,255,0.3)' },
                label: { show: false },
                labelLine: { show: false }
              }]
            }]
        },
        option_Progress2: {
          title: {
            text: '',
            subtext: '100%',
            x: 'center',
            y: 50,
            itemGap: 10,
            textStyle: {
              color: '#B7E1FF',
              fontWeight: 'normal',
              fontFamily: '微软雅黑',
              fontSize: 10
            },
            subtextStyle: {
              color: '#B7E1FF',
              fontWeight: 'bolder',
              fontSize: 10,
              fontFamily: '微软雅黑'
            }
          },
          series: [{
            type: 'pie',
            center: ['50%', '50%'],
            radius: [41, 45],
            x: '0%',
            tooltip: { show: false },
            data: [{
              name: '数量',
              value: 100,
              itemStyle: { color: 'rgba(0,153,255,0.8)' },
              hoverAnimation: false,
              label: {
                show: false,
                position: 'center',
                textStyle: {
                  fontFamily: '微软雅黑',
                  fontWeight: 'bolder',
                  color: '#B7E1FF',
                  fontSize: 10
                }
              },
              labelLine: {
                show: false
              }
            },
              {
                name: '79%',
                value: 0,
                itemStyle: { color: 'rgba(0,153,255,0.1)' },
                hoverAnimation: false,
                label: {
                  show: false,
                  position: 'center',
                  padding: 20,
                  textStyle: {
                    fontFamily: '微软雅黑',
                    fontSize: 10,
                    color: '#B7E1FF'
                  }
                },
                labelLine: {
                  show: false
                }
              }]
          },
            {
              type: 'pie',
              center: ['50%', '50%'],
              radius: [47, 50],
              x: '0%',
              hoverAnimation: false,
              data: [{
                value: 100,
                itemStyle: { color: 'rgba(0,153,255,0.3)' },
                label: { show: false },
                labelLine: { show: false }
              }]
            }]
        },
        option_Progress3: {
          title: {
            text: '',
            subtext: '100%',
            x: 'center',
            y: 50,
            itemGap: 10,
            textStyle: {
              color: '#B7E1FF',
              fontWeight: 'normal',
              fontFamily: '微软雅黑',
              fontSize: 10
            },
            subtextStyle: {
              color: '#B7E1FF',
              fontWeight: 'bolder',
              fontSize: 10,
              fontFamily: '微软雅黑'
            }
          },
          series: [{
            type: 'pie',
            center: ['50%', '50%'],
            radius: [41, 45],
            x: '0%',
            tooltip: { show: false },
            data: [{
              name: '数量',
              value: 100,
              itemStyle: { color: 'rgba(0,153,255,0.8)' },
              hoverAnimation: false,
              label: {
                show: false,
                position: 'center',
                textStyle: {
                  fontFamily: '微软雅黑',
                  fontWeight: 'bolder',
                  color: '#B7E1FF',
                  fontSize: 10
                }
              },
              labelLine: {
                show: false
              }
            },
              {
                name: '79%',
                value: 0,
                itemStyle: { color: 'rgba(0,153,255,0.1)' },
                hoverAnimation: false,
                label: {
                  show: false,
                  position: 'center',
                  padding: 20,
                  textStyle: {
                    fontFamily: '微软雅黑',
                    fontSize: 10,
                    color: '#B7E1FF'
                  }
                },
                labelLine: {
                  show: false
                }
              }]
          },
            {
              type: 'pie',
              center: ['50%', '50%'],
              radius: [47, 50],
              x: '0%',
              hoverAnimation: false,
              data: [{
                value: 100,
                itemStyle: { color: 'rgba(0,153,255,0.3)' },
                label: { show: false },
                labelLine: { show: false }
              }]
            }]
        },
        option_Progress4: {
          title: {
            text: '',
            subtext: '100%',
            x: 'center',
            y: 50,
            itemGap: 10,
            textStyle: {
              color: '#B7E1FF',
              fontWeight: 'normal',
              fontFamily: '微软雅黑',
              fontSize: 10
            },
            subtextStyle: {
              color: '#B7E1FF',
              fontWeight: 'bolder',
              fontSize: 10,
              fontFamily: '微软雅黑'
            }
          },
          series: [{
            type: 'pie',
            center: ['50%', '50%'],
            radius: [41, 45],
            x: '0%',
            tooltip: { show: false },
            data: [{
              name: '数量',
              value: 100,
              itemStyle: { color: 'rgba(0,153,255,0.8)' },
              hoverAnimation: false,
              label: {
                show: false,
                position: 'center',
                textStyle: {
                  fontFamily: '微软雅黑',
                  fontWeight: 'bolder',
                  color: '#B7E1FF',
                  fontSize: 10
                }
              },
              labelLine: {
                show: false
              }
            },
              {
                name: '79%',
                value: 0,
                itemStyle: { color: 'rgba(0,153,255,0.1)' },
                hoverAnimation: false,
                label: {
                  show: false,
                  position: 'center',
                  padding: 20,
                  textStyle: {
                    fontFamily: '微软雅黑',
                    fontSize: 10,
                    color: '#B7E1FF'
                  }
                },
                labelLine: {
                  show: false
                }
              }]
          },
            {
              type: 'pie',
              center: ['50%', '50%'],
              radius: [47, 50],
              x: '0%',
              hoverAnimation: false,
              data: [{
                value: 100,
                itemStyle: { color: 'rgba(0,153,255,0.3)' },
                label: { show: false },
                labelLine: { show: false }
              }]
            }]
        },
      }
    },
    created () {

    },
    beforeDestroy() {

    },
    mounted () {
      this.initChart()
    },
    methods: {
      async initChart () {
        this.y_gauge1 = this.$echarts.init(this.$refs.gauge1_ref)
        this.y_gauge2 = this.$echarts.init(this.$refs.gauge2_ref)
        this.y_gauge3 = this.$echarts.init(this.$refs.gauge3_ref)
        this.y_gauge4 = this.$echarts.init(this.$refs.gauge4_ref)

        this.option_Progress1.title.text = '现在司机'
        this.option_Progress1.title.subtext = this.driverInfoCount + '人'
        this.y_gauge1.setOption(this.option_Progress1)

        this.option_Progress2.title.text = '现有车辆'
        this.option_Progress2.title.subtext = this.vehicleCount + '辆'
        this.y_gauge2.setOption(this.option_Progress2)

        this.option_Progress3.title.text = '运单量'
        this.option_Progress3.title.subtext = this.waybillCount + '单'
        this.y_gauge3.setOption(this.option_Progress3)

        this.option_Progress4.title.text = '项目量'
        // this.option_Progress4.title.subtext = this.orderCount + '单'
        this.option_Progress4.title.subtext = this.clientContractCount + '个'
        this.y_gauge4.setOption(this.option_Progress4)
    }
    }
  }
</script>

<style scoped>
  #container {
    /*border: 1px solid beige;*/
  }

  .title {
    /*padding: 10px 0;*/
    text-align: center;
  }

  #gauge-content {
    width: 100%;
    box-sizing: border-box;
    height: 100%;
    /*overflow: hidden;*/

    margin-left: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  #y_gauge1, #y_gauge2, #y_gauge3, #y_gauge4 {
    width: 22%;
    height: 140px;
  }

  .order {
    margin-top: 4%;
  }
</style>
